import { authActions } from './auth-slice';
import { fetchMyProfile } from '../../lib/api';
import { getData } from '../common-actions';

import * as constants from "../../constants/authConstants";

export const getMyProfile = (token, signal) => {
  return getData({
    token: token,
    actions: authActions,
    fetchFn: (token) => fetchMyProfile(token, signal),
    dataKey: "profile",
    name: "get profile",
    setFunctionName: "setProfile",
  });

  /*
  return async (dispatch) => {

    //const {sendRequest, status, skills, error} = useHttp(fetchskills);
    //const {token} = useSelector(state => state.auth);

    const myUser = await fetchMyProfile(token);

    dispatch(
        authActions.setProfile({profile: myUser})
    );
  };*/
};

export const login = (token, expiresAt, tokenRefreshFlag) => {
  return (dispatch) => {
    if (token) {
      window.localStorage.setItem(constants.STORAGE_TOKEN, token);
    }
    
    if (expiresAt) {
      window.localStorage.setItem(constants.STORAGE_TOKEN_EXPIRES_AT, expiresAt);
    }

    console.log(`Token: ${token}`);
    dispatch(authActions.setAuth({token: token, expiresAt: expiresAt && expiresAt.toString ? expiresAt.toString() : expiresAt, tokenRefreshFlag: !!tokenRefreshFlag}));
  }
}

export const logout = (parameters = {}) => {
  return (dispatch) => {
    localStorage.removeItem(constants.STORAGE_TOKEN);
    localStorage.removeItem(constants.STORAGE_TOKEN_EXPIRES_AT);
    localStorage.removeItem(constants.STORAGE_REDIRECT_AFTER_LOGIN);
    dispatch(authActions.setAuth({token: null, doRedirectLogout: !!parameters.doRedirectLogout, tokenRefreshFlag: !!parameters.tokenRefreshFlag}));
  }
}

export const refreshToken = () => {
    console.log("Auth-Actions - refresh token");
  return (dispatch) => {
/*
    localStorage.removeItem(constants.STORAGE_TOKEN);
    localStorage.removeItem(constants.STORAGE_TOKEN_EXPIRES_AT);
    localStorage.removeItem(constants.STORAGE_REDIRECT_AFTER_LOGIN);
*/
    window.sessionStorage.removeItem(constants.STORAGE_TOKEN);
    window.sessionStorage.removeItem(constants.STORAGE_TOKEN_EXPIRES_AT);
    window.sessionStorage.removeItem(constants.STORAGE_REDIRECT_AFTER_LOGIN);
  }
}